import { render, staticRenderFns } from "./AnswersForPrint.vue?vue&type=template&id=f3002682&"
import script from "./AnswersForPrint.vue?vue&type=script&lang=js&"
export * from "./AnswersForPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports